import { render, staticRenderFns } from "./maintainPoint.vue?vue&type=template&id=199671dc&scoped=true&"
import script from "./maintainPoint.vue?vue&type=script&lang=js&"
export * from "./maintainPoint.vue?vue&type=script&lang=js&"
import style0 from "./maintainPoint.vue?vue&type=style&index=0&id=199671dc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "199671dc",
  null
  
)

export default component.exports